'use client';

import dynamic from 'next/dynamic';
import type { ReactNode } from 'react';
import type { PrintHost } from '@alltrails/print/components/PrintModal/PrintModal';
import { useExploreMapControls } from '@/components/ExploreMap/ExploreMapControlsContext';
import renderPrintSignUpModal from './renderPrintSignUpModal';

const PrintUpsellModal = dynamic(() => import('@alltrails/upsell/components/PrintUpsellModal/PrintUpsellModal'), { ssr: false });

/**
 * What the shared explore map contributes to a print, whatever opens it. The route supplies only
 * where the print is coming from and what it draws on top of the map's own overlays.
 */
const usePrintHost = (mapLocation: PrintHost['mapLocation'], mapContent?: ReactNode, trailId?: number): PrintHost => {
  const { handleFailedEntitlementCheck, isLayerUpsellOpen, mapOverlays } = useExploreMapControls();

  return {
    handleFailedEntitlementCheck,
    // Overlays first so the route, its pins and its photos stack above them, as on the live map
    mapContent: (
      <>
        {mapOverlays}
        {mapContent}
      </>
    ),
    mapLocation,
    pauseFocusTrap: isLayerUpsellOpen,
    renderSignUpModal: renderPrintSignUpModal,
    renderUpsellModal: upsellProps => <PrintUpsellModal {...upsellProps} upsellTrigger="Print Map" />,
    trailId
  };
};

export default usePrintHost;
